import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  selectFolder: {
    defaultValue: 'Selecionar pasta',
    key: 'select-dashboard-folder-selectFolder',
  },
  addedToFolder: {
    defaultValue: 'Dashboard adicionado à pasta',
    key: 'select-dashboard-folder-addedToFolder',
  },
  noFolders: {
    defaultValue: 'Nenhuma pasta criada',
    key: 'select-dashboard-folder-noFolders',
  },
})
